export default {
  title: 'Wstrzymaj dostępność',
  description: 'Wszystkie miejsca zajęte?',
  pause_availabilities: {
    pause_until_end_of_day: 'Wstrzymać rezerwacje do końca dnia?',
    pause_specific_time: 'Wstrzymaj rezerwacje na inny dzień i/lub godzinę',
  },
  pause_reservations_today: 'Wstrzymaj rezerwacje dziś',
  pause_reservations_another_day: 'Wstrzymaj rezerwacje na inny dzień',
  paused_availabilities_form: {
    date_time: {
      label: 'Wybierz datę i godzinę',
    },
    reason: {
      label: 'Dodaj powód (opcjonalnie)',
      placeholder: 'Wprowadź opis...',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  error_messages: {
    creation_failed: 'Nie udało się utworzyć wyjątku',
  },
};
